export const IPFS_GATEWAY_URI = "https://ipfs.io/ipfs"